const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export class ApiError extends Error {
  code: string;
  status: number;
  details?: Record<string, unknown>;

  constructor(
    error: { code: string; message: string; details?: Record<string, unknown> },
    status: number,
  ) {
    super(error.message);
    this.code = error.code;
    this.status = status;
    this.details = error.details;
  }
}

let getToken: (() => Promise<string | null>) | null = null;

export function setTokenGetter(fn: () => Promise<string | null>) {
  getToken = fn;
}

async function request<T>(path: string, options: RequestInit): Promise<T> {
  const token = getToken ? await getToken() : null;
  const res = await fetch(`${API_BASE_URL}/v1${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const json = await res.json();
  if (json.error) throw new ApiError(json.error, res.status);
  return json.data as T;
}

export async function api<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  try {
    return await request<T>(path, options);
  } catch (err) {
    // Retry once for 500 errors (not 4xx)
    if (err instanceof ApiError && err.status >= 500) {
      if (import.meta.env.DEV) {
        console.warn(`[api] Retrying ${path} after ${err.status} error`);
      }
      await new Promise((r) => setTimeout(r, 2000));
      return request<T>(path, options);
    }
    if (import.meta.env.DEV && err instanceof Error) {
      console.error(`[api] ${path}:`, err.message);
    }
    throw err;
  }
}
